export class AddressFormatterValidation {
    static areAllBlockValuesValid(block) {
        return block.fields.every((field) => {
            return field.required ? field.value : true;
        });
    }
}
